var React = require('react');

function Poop (props) {
    return React.createElement("svg",props,React.createElement("g",{"clipPath":"url(#a)","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},[React.createElement("path",{"d":"M10 12h.01M14 12h.01M10 16a3.5 3.5 0 0 0 4 0","key":0}),React.createElement("path",{"d":"M11 4c2 0 3.5 1.5 3.5 4h.164a2.5 2.5 0 0 1 2.196 3.32 3 3 0 0 1 1.615 3.063 3 3 0 0 1-1.299 5.607H7a3 3 0 0 1-1.474-5.613 3 3 0 0 1 1.615-3.062 2.5 2.5 0 0 1 2.195-3.32H9.5c1.5 0 2.5-2 1.5-4V4z","key":1})]));
}

Poop.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = Poop;

Poop.default = Poop;
